import {
    UserMetadataItem,
    MetadataType,
    PortalTextSettings,
    UserStatusType,
} from '../../../Models/Api/strongbox.financialportal';

import { InputStringContainsDangerousContent } from '../../../Utils/FormUtils';

import { UserRoleAdministrator, UserRoleDefaultUser } from '../../../Utils/Constants';

export type AddUsersMode = 'editrequired' | 'editmetadata';

export type AddUsersMetaDataItem = {
    metaDataItem: UserMetadataItem;
    contentIsValid: boolean;
};

export function IsMetadataInputValid(value: string, type: MetadataType): boolean {
    return !InputStringContainsDangerousContent(value);
}

export function GetRoleDescriptionFromId(roleid: string, settingsText?: PortalTextSettings): string {
    switch (roleid) {
        case UserRoleDefaultUser:
            return settingsText?.addUserDefaultUser || '';
        case UserRoleAdministrator:
            return settingsText?.addUserAdministrator || '';
    }
    return '';
}

export function GetUserStatusDescription(status: UserStatusType, settingsText?: PortalTextSettings): string {
    switch (status) {
        case 'Active':
            return settingsText?.userStatusActive || '';
        case 'Deleted':
            return settingsText?.userStatusDeleted || '';
        case 'Invited':
            return settingsText?.userStatusInvited || '';
        case 'PendingInvite':
            return settingsText?.userStatusPendingInvite || '';
    }
    return '';
}